import { render, staticRenderFns } from "./StorageRoomTable.vue?vue&type=template&id=0169698e"
import script from "./StorageRoomTable.vue?vue&type=script&lang=js"
export * from "./StorageRoomTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports